import __request__ from "routing/request";
export function createFromBuilder(rule, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rulebuilder", rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function actions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rulebuilder/actions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function conditions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rulebuilder/conditions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function simulate(rule, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rulebuilder/simulate", rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function validate(rule, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rulebuilder/validate", rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateFromBuilder(rule, id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.pipelineprocessor/system/pipelines/rulebuilder/${id}`, rule, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
